import { LevelType } from '../types/Level';
import { ORDERED_TYPES } from './planner';
import { MAX_BATCH } from './pipeline';

export const DEFAULT_FILL = 6;

// The type whose last appearance is the furthest back. Types never used share the lowest
// position, and the order of ORDERED_TYPES settles which of them goes first.
const mostOverdue = (lastSeen: Record<LevelType, number>): LevelType =>
  ORDERED_TYPES.reduce((best, type) => (lastSeen[type] < lastSeen[best] ? type : best));

// How many levels of each type to order so that the types missing the longest come back first.
// Levels are numbered in play order; the levels waiting in the queue are taken to come right after them.
export const fillGaps = (
  levels: { id: string; levelType: LevelType }[],
  queued: { levelType: LevelType }[],
  total: number
): Record<LevelType, number> => {
  const played = levels
    .map(level => ({ number: parseInt(level.id, 10), type: level.levelType }))
    .filter(item => !isNaN(item.number))
    .sort((a, b) => a.number - b.number)
    .map(item => item.type);
  const sequence = [...played, ...queued.map(draft => draft.levelType)];

  const lastSeen = {} as Record<LevelType, number>;
  const counts = {} as Record<LevelType, number>;
  ORDERED_TYPES.forEach(type => {
    lastSeen[type] = sequence.lastIndexOf(type);
    counts[type] = 0;
  });

  const wanted = Math.min(MAX_BATCH, Math.max(0, Math.floor(Number(total) || 0)));
  for (let i = 0; i < wanted; i++) {
    const next = mostOverdue(lastSeen);
    counts[next] += 1;
    lastSeen[next] = sequence.length + i;
  }
  return counts;
};
